import React from 'react';
import cn from 'classnames';
import { Switch } from 'antd';
import styles from './SwitchField.module.scss';
import FormItem from '../FormItem/FormItem';

const SwitchField = ({
  label,
  name,
  getFieldDecorator,
  options,
  colon = false,
  className,
  ...props
}) => {
  return (
    <FormItem
      {...props}
      colon={colon}
      label={label}
      className={cn(styles.switch, className)}
    >
      {getFieldDecorator(name, { valuePropName: 'checked', ...options })(
        <Switch />
      )}
    </FormItem>
  );
};

export default SwitchField;
